const NO_GRADIENT = ["", "none"];

function describe(value) {
  return typeof value === "object" ? JSON.stringify(value) : String(value);
}

function isSourceValueLeaf(value) {
  return value !== null && typeof value === "object" && typeof value.source === "string" && typeof value.value === "string";
}

function gradientString(gradient) {
  if (typeof gradient === "string") {
    return gradient;
  }
  if (isSourceValueLeaf(gradient) && gradient.source === "custom") {
    return gradient.value;
  }
  if (isSourceValueLeaf(gradient) && gradient.source === "theme.gradient" && gradient.value === "none") {
    return "none";
  }
  throw new TypeError(`background-gradient must be a CSS string such as "linear-gradient(...)" or "none", got ${describe(gradient)}`);
}

export function composeBackgroundLayers(gradient, imageLayer) {
  if (!imageLayer) {
    if (gradient !== undefined && gradient !== null && typeof gradient !== "string" && !isSourceValueLeaf(gradient)) {
      throw new TypeError(`background-gradient must be a CSS string such as "linear-gradient(...)" or "none", got ${describe(gradient)}`);
    }
    return gradient;
  }
  if (typeof imageLayer !== "string" || !imageLayer.startsWith("url(")) {
    throw new TypeError(`the background-image layer must be a url() string, got ${describe(imageLayer)}`);
  }
  if (gradient === undefined || gradient === null) {
    return imageLayer;
  }
  const css = gradientString(gradient);
  return NO_GRADIENT.includes(css.trim()) ? imageLayer : `${css}, ${imageLayer}`;
}
